import { useParentItemsFromSelectedSubItems, useSelectionState } from '../../state/selection.state';

import { BulkEditActivateButton } from './BulkEditActivateButton';
import { BulkEditEditButton } from './BulkEditEditButton';
import { BulkEditInactivateButton } from './BulkEditInactivateButton';
import { BulkEditPillBar } from './BulkEditPillBar';
import Switch from '@ingka/switch';
import styled from '@emotion/styled';
import { useBulkEditState } from './bulk-edit.state';

export const BulkEditToolbar = () => {
   const [hideInactive, toggleHideInactive] = useSelectionState(state => [state.hideInactive, state.toggleHideInactive])
   const { resetRowSelection } = useBulkEditState()

   const handleToggleHideInactive = () => {
      toggleHideInactive()
      resetRowSelection()
   }
   const items = useParentItemsFromSelectedSubItems(false);

   return (
      <div>
         <p><b>{items.length}</b> items selected</p>

         <StyledToolbarLeftDiv>
            <BulkEditPillBar />
            <StyledSwitch id="hideInactiveSwitch" value="hideInactive" checked={hideInactive} onChange={() => handleToggleHideInactive()} label="Exclude inactive parts" />
            <StyledToolbarRightDiv>
               <BulkEditInactivateButton />
               <BulkEditActivateButton />
               <BulkEditEditButton />
            </StyledToolbarRightDiv>
         </StyledToolbarLeftDiv>
      </div>
   );
};

const StyledToolbarLeftDiv = styled.div`
   display: flex;
   align-items: center;
   gap: 2em;
`;

const StyledToolbarRightDiv = styled.div`
   align-items: center;
   display: flex;
   margin-left: auto;
`;

const StyledSwitch = styled(Switch)`
  align-items: center;
  flex-shrink: 0;
`
